import { Card } from "../../../../../components/Card";
import { Flex, Image, Link, Text } from "@chakra-ui/react";

function ClimateActionGraphic({ data }) {
  const graphicSrc = require(`../../../../../assets/graphics/${data.keyName}_climate_action_graphic.png`);
  return (
    <Card>
      <Image src={graphicSrc} />
      <Flex marginTop="5" gap={2} alignItems="center" justifyContent="center">
        <Text>Source:</Text>
        <Link
          color={"esg_blue"}
          textDecoration="underline"
          isExternal
          href={data.graphicSource}>
          {data.graphicSource}
        </Link>
      </Flex>
    </Card>
  )
}

export default ClimateActionGraphic;